/**
 * Возвращает определенную величину
 */
export const getDefinedValue = <T, P>(firstValue: T, secondValue: P) =>
  typeof firstValue !== 'undefined' ? (firstValue as Exclude<T, undefined>) : secondValue;
